import { Link } from '@chakra-ui/next-js';
import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { HiArrowRight } from 'react-icons/hi';

import { Section } from '$components/layout/section';
import { FadeIn } from '$components/ui/fade-in';
import { ProjectCard } from '$components/ui/project-card';
import { projectsDisclaimer } from '$shared/bio';

export type Category = 'web' | 'mobile' | 'api' | 'other';

export interface Project {
  slug: string;
  name: string;
  description: string;
  category: Category;
  url?: string | null;
  repository?: string | null;
  techs: string[];
  thumbnail?: string | null;
}

export interface ProjectsProps {
  projects: Project[];
}

export function Projects({ projects }: ProjectsProps) {
  return (
    <Section
      dataScroll="projects"
      eyebrow="Projetos pessoais"
      title="O que andei construindo."
    >
      <FadeIn mb="32px">
        <Text
          fontSize={{ base: '15px', md: '16px' }}
          color="text.muted"
          maxW="58ch"
          fontStyle="italic"
        >
          {projectsDisclaimer}
        </Text>
      </FadeIn>

      <Box>
        {projects.map((project, index) => (
          <FadeIn key={project.slug} delay={index * 60}>
            <ProjectCard project={project} index={index} />
          </FadeIn>
        ))}
      </Box>

      <Flex justify="flex-end" mt="24px">
        <Link
          href="/projects"
          display="inline-flex"
          alignItems="center"
          gap="8px"
          fontFamily="mono"
          fontSize="12px"
          letterSpacing="0.08em"
          color="text.primary"
          _hover={{ color: 'accent.500', textDecoration: 'none' }}
          transition="color 0.2s ease"
        >
          Ver todos os projetos <Icon as={HiArrowRight} />
        </Link>
      </Flex>
    </Section>
  );
}
